import React from 'react';
import PropTypes from 'prop-types';

import { Button, Container, AddIcon } from './CreateButton.styled';

const CreateButton = ({ onShowCreateAssignment }) => (
  <Container>
    <Button
      onClick={onShowCreateAssignment}
      data-testid="new-assignment-button"
      size="small"
      icon={AddIcon}
    >
      New assignment
    </Button>
  </Container>
);

CreateButton.propTypes = {
  onShowCreateAssignment: PropTypes.func.isRequired,
};

export default CreateButton;
